import React, { useEffect, useState } from "react";
import Constants from "../Constants";
import Answer from "./poll/answer";
import Pic from "./poll/pic";

const Poll = ({ csrf }) => {
  const [showPoll, setShowPoll] = useState(false);
  const [voted, setVoted] = useState(false);
  const [poll, setPoll] = useState({ answers: [] });
  const [selectedAnswer, setSelectedAnswer] = useState(0);
  const [voting, setVoting] = useState(false);
  useEffect(() => {
    fetch(`${Constants.API}get-poll`)
      .then((res) => res.json())
      .then((res) => {
        if (res.poll) {
          if (localStorage.getItem(`hv_${res.poll.id}`) === null) {
            setPoll(res.poll);
            setShowPoll(true);
          }
        }
      });
  }, []);
  const handleChange = (e) => {
    if (voting) return;
    setVoting(true);
    let answerID = parseInt(e.target.value);
    setSelectedAnswer(answerID);
    const formData = new FormData();
    formData.append("answer", answerID);
    fetch(`${Constants.API}voting-on-poll`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-XSRF-TOKEN": csrf,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if ("success" in res) {
          setVoting(false);
          localStorage.setItem(`hv_${poll.id}`, `y`);
          setVoted(true);
          setShowPoll(false);
          setTimeout(() => {
            setVoted(false);
          }, 5000);
        }
      });
  };
  if (voted) {
    return (
      <div className="poll">
        <h2>Thank you for voting.</h2>
      </div>
    );
  }
  if (!showPoll) {
    return null;
  }
  return (
    <div className="poll">
      <h2>Poll: {poll.question}</h2>
      <div className="answers_poll">
        {poll.answers.map((a) => {
          if (a.has_pic === "y") {
            return (
              <Pic
                key={`answer_${a.id}`}
                handleChange={handleChange}
                answer={a}
                isSelected={selectedAnswer === a.id}
              />
            );
          } else {
            return (
              <Answer
                key={`answer_${a.id}`}
                handleChange={handleChange}
                answer={a}
                isSelected={selectedAnswer === a.id}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default Poll;
